import { Box, TextField } from '@mui/material';
import PropTypes from 'prop-types';

import withStyles from '../mui/withStylesAdapter';

const withJss = withStyles(theme => ({
  specName: {
    fontWeight: 'bold',
    fontSize: theme.utils.pxToRem(16),
    width: '264px',
  },
  specContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8rem',
    width: '400px',
    paddingTop: '2rem',
  },
}));

function SpecInput({ spec, classes, onChange }) {
  const [specId, specValues] = spec;

  return (
    <Box className={classes.specContainer}>
      <div className={classes.specName}>{specValues.name}</div>
      <TextField
        className={classes.specInput}
        value={specValues.value}
        id={`calc-input-${specValues.testId}`}
        data-testid={`calc-input-${specValues.testId}`}
        min={specValues.min}
        max={specValues.max}
        type="number"
        variant="outlined"
        inputProps={{
          ...(specValues.step && { step: specValues.step }),
        }}
        onChange={ev => {
          onChange(specId, ev.target.value);
        }}
      />
    </Box>
  );
}

SpecInput.propTypes = {
  spec: PropTypes.array.isRequired,
  classes: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
};

export default withJss(SpecInput);
